"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NotificationList = require("./NotificationList");
Object.keys(_NotificationList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotificationList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NotificationList[key];
    }
  });
});
